export const rewriteEditorHtmlForEmail = (html: string): string => {
  if (!html) return html;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('img[data-cid]').forEach((img) => {
    const cid = img.getAttribute('data-cid');
    if (cid) img.setAttribute('src', `cid:${cid}`);
    img.removeAttribute('data-cid');
  });
  return doc.body.innerHTML;
};

export const collectReferencedCids = (html: string): Set<string> => {
  const referenced = new Set<string>();
  if (!html) return referenced;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('img').forEach((img) => {
    const dataCid = img.getAttribute('data-cid');
    if (dataCid) referenced.add(dataCid);
    const src = img.getAttribute('src') ?? '';
    if (src.startsWith('cid:')) referenced.add(src.slice(4));
  });
  return referenced;
};
